import "./styles.css";
import { HomePage } from "./components/pages/index";

function App() {
  return <HomePage />;
}

export default App;
